import {putResolve, takeLeading, select, throttle} from 'redux-saga/effects';
import {RESTAURANT, RESTAURANT_FAILURE, RESTAURANT_REQUEST, RESTAURANT_SUCCESS} from 'new-constants/api.constants';
import {getRestaurant} from 'new-actions/api.actions.ts';
import {getCurrentRestaurantIdSelector} from "../selectors";

function isRestaurantNotFetched(restaurant, currentRestaurantId) {
	return !restaurant.cache.find(
		restaurant => restaurant.restaurantId === currentRestaurantId
	);
}

function isRestaurantOutdated(customer, restaurant) {
	if (!(customer && customer.restaurant && customer.restaurant.restaurantId && customer.restaurant.version)) {
		return false;
	}

	const currentRestaurant = restaurant.cache.find(
		restaurant => restaurant.restaurantId === customer.restaurant.restaurantId
	);

	if (
		customer.restaurant.restaurantId !== currentRestaurant.restaurantId ||
		customer.restaurant.version !== currentRestaurant.version ||
		customer.locale !== currentRestaurant.locale ||
		customer.customerGroupIds !== currentRestaurant.customerGroupIds
	) {
		return true;
	}

	return false;
}

function* getRestaurantIfNecessary() {
	const state = yield select();
	const {customer, restaurant, appState, connectivity, restaurantList, fetchProgress} = state;

	if (fetchProgress[RESTAURANT]) {
		return;
	}

	const currentRestaurantId = getCurrentRestaurantIdSelector(state);

	if (
		(isRestaurantNotFetched(restaurant, currentRestaurantId) ||
			isRestaurantOutdated(customer.currentCustomer, restaurant)) &&
		currentRestaurantId &&
		connectivity.isOnline !== false
	) {
		yield putResolve(
			getRestaurant(
				currentRestaurantId,
				customer.currentCustomer?.restaurant?.version,
				customer.currentCustomer?.locale,
				customer.currentCustomer?.customerGroupIds
			)
		);
	}
}

export const restaurantUpdaterSaga = function* restaurantUpdaterSaga() {
	yield throttle(
		2500,
		[action => ![RESTAURANT_REQUEST, RESTAURANT_SUCCESS, RESTAURANT_FAILURE].includes(action.type)],
		getRestaurantIfNecessary
	);
};
